<template>
  <div>
    <div
      class="card"
      :class="{ [toolbarClass]: true, 'mb-5': toolbarClass === '' }"
      v-if="!hideTitle"
      style="position: relative; z-index: 100"
    >
      <div>
        <div
          v-if="!slave"
          class="card-header rounded-xl border-0 py-5 px-0 d-flex flex-column"
          style="min-height: unset"
        >
          <!-- title row -->
          <div
            class="d-flex align-items-center border-1 border-bottom px-8 pb-5 mb-5"
          >
            <slot name="header-title">
              <h4 v-if="!hideTitle" class="font-weight-bold mb-0">
                <i
                  v-if="titleIcon"
                  class="font-size-h3 mr-1 text-primary font-weight-normal"
                  :class="titleIcon"
                ></i>
                <span v-if="titleKey">{{ $t(`menu.${titleKey}`) }}</span>
                <span v-else>{{ title }}</span>
              </h4>
            </slot>

            <div
              class="d-flex align-items-center ml-auto"
              v-if="toolbar !== false"
            >
              <slot name="custom-event-button">
                <b-button
                  v-if="$_sys.isAllowed(permission.create) && customEvent"
                  :variant="customEvent.variant || 'warning'"
                  class="mr-2"
                  @click="emitEvent('custom_event')"
                >
                  <i
                    v-if="customEvent.icon"
                    :class="customEvent.icon"
                    class="mr-1"
                  ></i>
                  {{ customEvent.label || 'Custom Action' }}
                </b-button>
              </slot>

              <slot name="create-button">
                <b-button
                  variant="primary"
                  v-if="$_sys.isAllowed(permission.create) && !hideCreate"
                  @click="emitEvent('add_new')"
                >
                  <i class="ri-add-circle-fill"></i> Tambah Data
                </b-button>
              </slot>
            </div>

          </div>

          <!-- filter row -->
          <b-row class="align-items-center py-2 px-8" v-if="!hideFilter">
            <!-- search & main filter  -->
            <b-col class="pr-0 mb-5 mb-lg-0">
              <b-row class="align-items-center">
                <!-- search  -->
                <b-col class="pr-8 pr-md-0 mb-5 mb-md-0">
                  <!-- search -->
                  <slot name="header-search">
                    <!-- class="input-icon pr-5 bordered-right" -->
                    <div class="input-icon" v-if="search !== false">
                      <span>
                        <i class="ri-search-line text-primary"></i>
                      </span>
                      <input
                        v-model.lazy.trim="inputSearch"
                        autocomplete="off"
                        name="search"
                        type="text"
                        class="form-control seach-form"
                        :placeholder="$t('global.search') + ' ' + title"
                      />
                    </div>
                  </slot>
                </b-col>
                <!-- TOOLBAR MAIN FILTER -->
                <b-col cols="12" md="auto" class="pl-0">
                  <div
                    class="input-wrapper filter-wrapper d-flex flex-column justify-content-center pl-4"
                    v-for="(item, i) in filterData.filter((x) => x.main)"
                    :key="'filter-item-' + i"
                    v-b-tooltip="$t('global.filter') + ' ' + item.label"
                  >
                    <div
                      class="d-flex flex-row align-items-center"
                      v-if="
                        ['select', 'lookup', 'lookup-radio', 'radio'].includes(
                          item.type
                        )
                      "
                    >
                      <v-select
                        v-model="
                          paramAPI.filters[
                            item.view_data ? item.view_data : item.id
                          ]
                        "
                        :disabled="
                          item.option.parent_filter &&
                          !paramAPI['filters'][item.option.parent_filter]
                        "
                        label="label"
                        :placeholder="`${item.label}`"
                        :reduce="(x) => x.code"
                        :options="
                          Array.isArray(item.option.list_pointer.list)
                            ? item.option.list_pointer.list
                            : item.options
                        "
                        @option:selected="onFilter(item, $event)"
                        @open="
                          Array.isArray(item.option.list_pointer.list)
                            ? null
                            : getInitialData(item)
                        "
                        @search="
                          (search, loading) =>
                            searchDataOption(search, loading, item)
                        "
                        class="v-select-filter main"
                        :class="{
                          disabled:
                            !paramAPI.filters[
                              item.view_data ? item.view_data : item.id
                            ],
                        }"
                      >
                        <!-- <template v-slot:no-options="{ search, searching }">
                          <p>{{ search }}, {{ searching }}</p>
                        </template> -->
                      </v-select>
                    </div>
                    <date-picker
                      v-else-if="['date', 'daterange'].includes(item.type)"
                      :range="item.type === 'daterange'"
                      format="YYYY-MM-DD"
                      @input="onFilter(item, $event)"
                      :value="
                        item.data_type === 'array' &&
                        paramAPI.filters[item.params ? item.params : item.id]
                          ? paramAPI.filters[
                              item.params ? item.params : item.id
                            ][0]
                          : paramAPI.filters[
                              item.params ? item.params : item.id
                            ]
                      "
                      input-class="input-filter-daterange"
                      placeholder="Tanggal"
                      value-type="format"
                      @clear="onFilter(item, null)"
                    />

                    <div
                      class="d-flex flex-row align-items-center"
                      v-if="['year'].includes(item.type)"
                    >
                      <v-select
                        v-model="
                          paramAPI.filters[
                            item.view_data ? item.view_data : item.id
                          ]
                        "
                        label="label"
                        :placeholder="`${item.label}`"
                        :reduce="(x) => x.code"
                        :options="year_options"
                        @option:selected="onFilter(item, $event)"
                        class="v-select-filter"
                        :class="{
                          disabled:
                            !paramAPI.filters[
                              item.view_data ? item.view_data : item.id
                            ],
                        }"
                      >
                        <template v-slot:no-options="{ search, searching }">
                          <p>{{ search }}, {{ searching }}</p>
                        </template>
                      </v-select>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <!-- toolbar btn -->
            <b-col cols="12" lg="auto" class="d-flex align-items-center pl-0">
              <!-- Refresh -->
              <b-button
                v-if="toolbar !== false || hideRefresh === true"
                variant="outline-primary"
                pill
                class="ml-5 mr-2"
                @click="emitEvent('reload')"
              >
                <!-- :class="{ active: !filter }" -->
                <i class="ri-refresh-line"></i>
                Refresh
              </b-button>
              <!-- column view -->
              <b-button
                v-if="toolbar !== false"
                variant="outline-primary"
                class="btn-icon btn-circle mx-2"
                v-b-modal.modal-visibility
                v-b-tooltip.top="$t('global.visibility')"
              >
                <i class="ri-layout-3-line"></i>
              </b-button>
              <!-- filter btn -->
              <b-button
                :variant="showFilter ? 'primary' : 'outline-primary'"
                v-if="filterData.filter((x) => !x.main).length > 0"
                class="toolbar-button-icon icon-filter mx-2"
                :class="{ 'text-white': showFilter }"
                @click="showFilter = !showFilter"
                v-b-tooltip="$t('global.form_filter')"
              >
                <i class="ri-filter-2-line"></i>
              </b-button>
              <!-- btn export excel -->
              <b-button
                v-if="toolbar !== false && exportExcel !== false && exportPath"
                variant="outline-primary"
                @click="onExportExcell"
                :disabled="
                  permission.export
                    ? !$_sys.isAllowed(permission.export)
                    : false
                "
                class="ml-2 btn-icon btn-circle"
              >
                <i class="ri-file-excel-2-line"></i>
              </b-button>
            </b-col>
          </b-row>

          <!-- HIDDEN FILTER -->
          <div
            v-if="filterData.filter((x) => !x.main).length > 0 && showFilter"
            class="w-100 mt-3 pt-3 px-8"
            style="border-top: 1px dashed #e0e8f0"
          >
            <p class="mb-0 mt-3 animated">
              <i class="ri-filter-2-line"></i>
              <span class="font-weight-bolder">
                {{ $t("global.form_filter") }}
              </span>
            </p>
            <!-- filter input -->
            <div
              class="d-flex flex-wrap animated"
              style="position: relative; z-index: 2"
            >
              <div
                class="input-wrapper filter-wrapper pr-3 mt-3"
                v-for="(item, i) in filterData.filter((x) => !x.main)"
                :key="'filter-item-' + i"
                v-b-tooltip="$t('global.filter') + ' ' + item.label"
              >
                <v-select
                  v-if="
                    ['select', 'lookup', 'lookup-radio', 'radio'].includes(
                      item.type
                    )
                  "
                  v-model="
                    paramAPI.filters[item.params ? item.params : item.id]
                  "
                  label="label"
                  :placeholder="`${item.label}`"
                  :reduce="(x) => x.code"
                  :options="
                    Array.isArray(item.option.list_pointer.list)
                      ? item.option.list_pointer.list
                      : item.options
                  "
                  @option:selected="onFilter(item, $event)"
                  @open="
                    Array.isArray(item.option.list_pointer.list)
                      ? null
                      : getInitialData(item)
                  "
                  @search="
                    (search, loading) =>
                      Array.isArray(item.option.list_pointer.list)
                        ? null
                        : searchDataOption(search, loading, item)
                  "
                  class="v-select-filter"
                  :disabled="
                    item.option.parent_filter &&
                    !paramAPI['filters'][item.option.parent_filter]
                  "
                >
                </v-select>

                <date-picker
                  v-else-if="['date', 'daterange'].includes(item.type)"
                  :range="item.type === 'daterange'"
                  format="YYYY-MM-DD"
                  :value="
                    item.data_type === 'array' &&
                    paramAPI.filters[item.params ? item.params : item.id]
                      ? paramAPI.filters[item.params ? item.params : item.id][0]
                      : paramAPI.filters[item.params ? item.params : item.id]
                  "
                  @input="onFilter(item, $event)"
                  input-class="input-filter-daterange"
                  placeholder="Tanggal"
                  value-type="format"
                  @clear="
                    paramAPI.filters[item.params ? item.params : item.id] = null
                  "
                />
              </div>
            </div>
            <!-- reset btn -->
            <div
              class="d-flex flex-row align-items-center flex-1 animated mt-3"
              v-if="hideRefresh !== true"
            >
              <b-button variant="warning-light" @click="paramAPI.filters = {}">
                <i class="ri-refresh-line"></i>
                Reset
              </b-button>
            </div>
          </div>
          <!-- HIDDEN FILTER END -->
        </div>
      </div>
    </div>
    <slot name="list-middle"></slot>
    <!-- header-row slot -->
    <slot
      name="header-row"
      v-bind:rowData="dataSummary ? dataSummary : mainData"
      v-bind:indicator="indicator ? indicator : null"
      v-bind:loading="isLoading"
    >
    </slot>
    <!-- <slot name='header-table'></slot> -->

    <!-- other-options slots -->
     <!-- <div
      class="card"
      :class="{ [toolbarClass]: true, 'mb-5': toolbarClass === '' }"
      v-if="!hideTitle"
      style="position: relative; z-index: 100"
    >
      <div>
        <div
          class="card-header rounded-xl border-0 py-5 px-0 d-flex flex-column"
          style="min-height: unset"
        >
          <div
            class="d-flex flex-row align-items-center justify-content-between border-1 border-bottom px-8 pb-5 mb-5"
          >
            <slot name="header-title">
              <h4 v-if="!hideTitle" class="font-weight-bold pb-0 mb-0">
                <span v-if="titleKey"> Filter {{ $t(`menu.${titleKey}`) }}</span>
                <span v-else> Filter {{ title }}</span>
              </h4>
            </slot>
          </div>
          <b-row class="align-items-center py-2 px-8" v-if="!hideFilter">
            <b-col class="pr-0 mb-5 mb-lg-0">
              <b-row class="align-items-center">
                <b-col cols="12" md="auto" class="pl-0">
                  <div
                    class="input-wrapper filter-wrapper d-flex flex-column justify-content-center pl-4"
                    v-for="(item, i) in filterData.filter((x) => x.main)"
                    :key="'filter-item-' + i"
                    v-b-tooltip="$t('global.filter') + ' ' + item.label"
                  >
                    <div
                      class="d-flex flex-row align-items-center"
                      v-if="
                        ['select', 'lookup', 'lookup-radio', 'radio'].includes(
                          item.type
                        )
                      "
                    >
                      <v-select
                        v-model="
                          paramAPI.filters[
                            item.view_data ? item.view_data : item.id
                          ]
                        "
                        :disabled="
                          item.option.parent_filter &&
                          !paramAPI['filters'][item.option.parent_filter]
                        "
                        label="label"
                        :placeholder="`${item.label}`"
                        :reduce="(x) => x.code"
                        :options="
                          Array.isArray(item.option.list_pointer.list)
                            ? item.option.list_pointer.list
                            : item.options
                        "
                        @option:selected="onFilter(item, $event)"
                        @open="
                          Array.isArray(item.option.list_pointer.list)
                            ? null
                            : getInitialData(item)
                        "
                        @search="
                          (search, loading) =>
                            searchDataOption(search, loading, item)
                        "
                        class="v-select-filter main"
                        :class="{
                          disabled:
                            !paramAPI.filters[
                              item.view_data ? item.view_data : item.id
                            ],
                        }"
                      >
                      </v-select>
                    </div>
                    <date-picker
                      v-else-if="['date', 'daterange'].includes(item.type)"
                      :range="item.type === 'daterange'"
                      format="YYYY-MM-DD"
                      @input="onFilter(item, $event)"
                      :value="
                        item.data_type === 'array' &&
                        paramAPI.filters[item.params ? item.params : item.id]
                          ? paramAPI.filters[
                              item.params ? item.params : item.id
                            ][0]
                          : paramAPI.filters[
                              item.params ? item.params : item.id
                            ]
                      "
                      input-class="input-filter-daterange"
                      placeholder="Tanggal"
                      value-type="format"
                      @clear="onFilter(item, null)"
                    />

                    <div
                      class="d-flex flex-row align-items-center"
                      v-if="['year'].includes(item.type)"
                    >
                      <v-select
                        v-model="
                          paramAPI.filters[
                            item.view_data ? item.view_data : item.id
                          ]
                        "
                        label="label"
                        :placeholder="`${item.label}`"
                        :reduce="(x) => x.code"
                        :options="year_options"
                        @option:selected="onFilter(item, $event)"
                        class="v-select-filter"
                        :class="{
                          disabled:
                            !paramAPI.filters[
                              item.view_data ? item.view_data : item.id
                            ],
                        }"
                      >
                        <template v-slot:no-options="{ search, searching }">
                          <p>{{ search }}, {{ searching }}</p>
                        </template>
                      </v-select>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" lg="auto" class="d-flex align-items-center pl-0">

              <b-button
                :variant="showFilter ? 'primary' : 'outline-primary'"
                v-if="filterData.filter((x) => !x.main).length > 0"
                class="toolbar-button-icon icon-filter mx-2"
                :class="{ 'text-white': showFilter }"
                @click="showFilter = !showFilter"
                v-b-tooltip="$t('global.form_filter')"
              >
                <i class="ri-filter-2-line"></i>
              </b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div> -->
    <!-- list-card-body -->
    <slot
      name="list-card-body"
      v-bind:rowData="mainData"
      v-bind:loading="isLoading"
    >
      <div class="card card-custom">
        <!-- slave list header -->
        <div v-if="slave" class="slave-list-header">
          <div class="slave-list-header-title">
            <slot name="header-title">
              <h3
                v-if="titleKey && $t(`menu.${titleKey}` != `menu.${titleKey}`)"
              >
                {{ $t(`menu.${titleKey}`) }}
              </h3>
              <h3 v-else>{{ title }}</h3>
            </slot>
            <slot name="create-button">
              <div class="d-flex flex-row align-items-center">
                <div class="bordered-right">
                  <b-button
                    variant="primary"
                    v-if="$_sys.isAllowed(permission.create) && !hideCreate"
                    @click="emitEvent('add_new')"
                  >
                    <!-- <i class="ri-add-fill"></i> Tambah {{ title }} -->
                    <i class="ri-add-circle-fill"></i> Tambah Data
                  </b-button>
                </div>
              </div>
            </slot>
          </div>
        
          <!-- filter row -->
          <slot class="align-items-center py-2 mt-3" name="inline-filter"></slot>
          <b-row class="align-items-center py-2 mt-3" v-if="!hideFilter">
            <!-- search & main filter  -->
            <b-col class="pr-0 mb-5 mb-lg-0">
              <b-row class="align-items-center">
                <!-- search  -->
                <b-col class="pr-8 pr-md-0 mb-5 mb-md-0">
                  <!-- search -->
                  <slot name="header-search">
                    <!-- class="input-icon pr-5 bordered-right" -->
                    <div class="input-icon" v-if="search !== false">
                      <span>
                        <i class="ri-search-line text-primary"></i>
                      </span>
                      <input
                        v-model.lazy.trim="inputSearch"
                        autocomplete="off"
                        name="search"
                        type="text"
                        class="form-control seach-form"
                        :placeholder="$t('global.search') + ' ' + title"
                      />
                    </div>
                  </slot>
                </b-col>
                <!-- TOOLBAR MAIN FILTER -->
                <b-col cols="12" md="auto" class="pl-0">
                  <div
                    class="input-wrapper filter-wrapper d-flex flex-column justify-content-center pl-4"
                    v-for="(item, i) in filterData.filter((x) => x.main)"
                    :key="'filter-item-' + i"
                    v-b-tooltip="$t('global.filter') + ' ' + item.label"
                  >
                    <div
                      class="d-flex flex-row align-items-center"
                      v-if="
                        ['select', 'lookup', 'lookup-radio', 'radio'].includes(
                          item.type
                        )
                      "
                    >
                      <v-select
                        v-model="
                          paramAPI.filters[
                            item.view_data ? item.view_data : item.id
                          ]
                        "
                        :disabled="
                          item.option.parent_filter &&
                          !paramAPI['filters'][item.option.parent_filter]
                        "
                        label="label"
                        :placeholder="`${item.label}`"
                        :reduce="(x) => x.code"
                        :options="
                          Array.isArray(item.option.list_pointer.list)
                            ? item.option.list_pointer.list
                            : item.options
                        "
                        @option:selected="onFilter(item, $event)"
                        @open="
                          Array.isArray(item.option.list_pointer.list)
                            ? null
                            : getInitialData(item)
                        "
                        @search="
                          (search, loading) =>
                            searchDataOption(search, loading, item)
                        "
                        class="v-select-filter main"
                        :class="{
                          disabled:
                            !paramAPI.filters[
                              item.view_data ? item.view_data : item.id
                            ],
                        }"
                      >
                        <!-- <template v-slot:no-options="{ search, searching }">
                          <p>{{ search }}, {{ searching }}</p>
                        </template> -->
                      </v-select>
                    </div>
                    <date-picker
                      v-else-if="['date', 'daterange'].includes(item.type)"
                      :range="item.type === 'daterange'"
                      format="YYYY-MM-DD"
                      @input="onFilter(item, $event)"
                      :value="
                        item.data_type === 'array' &&
                        paramAPI.filters[item.params ? item.params : item.id]
                          ? paramAPI.filters[
                              item.params ? item.params : item.id
                            ][0]
                          : paramAPI.filters[
                              item.params ? item.params : item.id
                            ]
                      "
                      input-class="input-filter-daterange"
                      placeholder="Tanggal"
                      value-type="format"
                      @clear="onFilter(item, null)"
                    />

                    <div
                      class="d-flex flex-row align-items-center"
                      v-if="['year'].includes(item.type)"
                    >
                      <v-select
                        v-model="
                          paramAPI.filters[
                            item.view_data ? item.view_data : item.id
                          ]
                        "
                        label="label"
                        :placeholder="`${item.label}`"
                        :reduce="(x) => x.code"
                        :options="year_options"
                        @option:selected="onFilter(item, $event)"
                        class="v-select-filter"
                        :class="{
                          disabled:
                            !paramAPI.filters[
                              item.view_data ? item.view_data : item.id
                            ],
                        }"
                      >
                        <template v-slot:no-options="{ search, searching }">
                          <p>{{ search }}, {{ searching }}</p>
                        </template>
                      </v-select>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <!-- toolbar btn -->
            <b-col cols="12" lg="auto" class="d-flex align-items-center pl-0">
              <!-- Refresh -->
              <b-button
                v-if="toolbar !== false || hideRefresh === true"
                variant="outline-primary"
                pill
                class="ml-5 mr-2"
                @click="emitEvent('reload')"
              >
                <!-- :class="{ active: !filter }" -->
                <i class="ri-refresh-line"></i>
                Refresh
              </b-button>
              <!-- column view -->
              <b-button
                v-if="toolbar !== false"
                variant="outline-primary"
                class="btn-icon btn-circle mx-2"
                v-b-modal.modal-visibility
                v-b-tooltip.top="$t('global.visibility')"
              >
                <i class="ri-layout-3-line"></i>
              </b-button>
              <!-- filter btn -->
              <b-button
                :variant="showFilter ? 'primary' : 'outline-primary'"
                v-if="filterData.filter((x) => !x.main).length > 0"
                class="toolbar-button-icon icon-filter mx-2"
                :class="{ 'text-white': showFilter }"
                @click="showFilter = !showFilter"
                v-b-tooltip="$t('global.form_filter')"
              >
                <i class="ri-filter-2-line"></i>
              </b-button>
              <!-- btn export excel -->
              <b-button
                v-if="toolbar !== false && exportExcel !== false && exportPath"
                variant="outline-primary"
                @click="onExportExcell"
                :disabled="
                  permission.export
                    ? !$_sys.isAllowed(permission.export)
                    : false
                "
                class="ml-2 btn-icon btn-circle"
              >
                <i class="ri-file-excel-2-line"></i>
              </b-button>
            </b-col>
          </b-row>
        </div>

        <div class="card-body pb-0 pt-3"></div>

        <slot
          name="header-table"
          v-bind:rowData="mainData"
          v-bind:summary="dataSummary"
          v-bind:loading="isLoading"
        ></slot>

        <div class="card-body pt-2">
          <div class="table-responsive" style="position: relative">
            <div
              class="base-crud-table-loader"
              v-if="mainData.length > 0 && isLoading"
            >
              <img src="@/assets/lottie/plant.gif" style="width: 5em" />
            </div>
            <table
              class="table table-head-custom table-head-bg table-borderless table-hover"
              :class="{ [API]: true }"
            >
              <slot
                name="list-header-table"
                @click="emitEvent('orderField', d)"
              >
                <thead>
                  <tr>
                    <th
                      class="sticky"
                      v-if="
                        ($_sys.isAllowed(permission.read) ||
                          $_sys.isAllowed(permission.update) ||
                          $_sys.isAllowed(permission.delete)) &&
                        !hideAction
                      "
                      :colspan="detailPreview ? 2 : 1"
                    ></th>
                    <th v-if="indexNumber">No</th>
                    <th
                      class="position-relative"
                      v-for="(h, i) in orderedFields"
                      :key="i + '-header'"
                      :class="[
                        { sticky: i === -10 },
                        { pointer: h.order },
                        { [h.header_class]: true },
                      ]"
                      @click="orderField(h)"
                    >
                      <span
                        class="d-block nowrap"
                        :class="{ 'text-dark-75 mr-5': h.id === orderID }"
                        >{{ h.label }}</span
                      >
                      <i
                        v-if="h.id === orderID"
                        class="sort-table text-dark-75"
                        :class="'ri-sort-' + paramAPI.sort.toLowerCase()"
                      ></i>
                    </th>
                  </tr>
                </thead>
              </slot>
              <tbody v-if="mainData.length > 0">
                <!-- expandable view -->
                <template v-if="detailPreview">
                  <template v-for="(b, i) in mainData">
                    <tr
                      :key="i + '-body'"
                      :class="{
                        'detail-preview-active-row':
                          b && b.real && b.real.isActive,
                      }"
                    >
                      <td class="nowrap-table">
                        <slot name="expand-button" :row="b" :index="i" :toggle="() => toggleDetails(b, i)">
                          <b-button
                            v-if="!hideExpandButton"
                            @click="toggleDetails(b, i)"
                            :variant="b && b.real && b.real.isActive ? 'primary' : 'outline-primary'"
                            class="btn-icon btn-xs"
                            pill
                            :class="b && b.real && b.real.isActive ? 'detail-active' : ''"
                          >
                            <i
                              :class="b && b.real && b.real.isActive
                                ? 'ri-arrow-down-s-fill'
                                : 'ri-arrow-right-s-fill'"
                            ></i>
                          </b-button>
                        </slot>
                      </td>

                      <td
                        class="sticky action-table"
                        v-if="
                          !hideAction &&
                          ($_sys.isAllowed(permission.read) ||
                            $_sys.isAllowed(permission.update) ||
                            $_sys.isAllowed(permission.delete))
                        "
                      >
                        <div
                          class="d-flex flex-row justify-content-center align-items-center"
                          v-if="!hideAction"
                        >
                          <!-- Btn Action Detail  -->
                          <slot
                            name="table-action-detail-button"
                            v-bind:rowData="b.real"
                          >
                            <a
                              v-if="
                                !hideDetail && $_sys.isAllowed(permission.read)
                              "
                              v-b-tooltip.top.viewport="$t('global.detail')"
                              @click="emitEvent('detail', b.real)"
                              class="btn btn-icon btn-info btn-xs mx-1"
                              style="
                                background-color: rgba(0, 207, 232, 0.12);
                                border: none;
                              "
                            >
                              <slot name="table-action-detail-icon">
                                <i class="ri-information-line text-primary"></i>
                              </slot>
                            </a>
                          </slot>
                          <!-- Btn Action Edit  -->
                          <a
                            v-if="
                              !hideUpdate && $_sys.isAllowed(permission.update)
                            "
                            v-b-tooltip.top.viewport="$t('global.update')"
                            @click="emitEvent('update', b.real)"
                            class="btn btn-icon btn-warning btn-xs mx-1"
                            style="
                              background-color: rgba(255, 159, 67, 0.12);
                              border: none;
                            "
                          >
                            <i class="ri-edit-2-line text-warning"></i>
                          </a>
                          <!-- Btn Action Delete  -->
                          <a
                            v-b-tooltip.top.viewport="$t('global.delete')"
                            @click="deleteData(b.real)"
                            v-if="
                              !hideDelete && $_sys.isAllowed(permission.delete)
                            "
                            class="btn btn-icon btn-danger btn-xs mx-1"
                            style="background-color: #ffe2e5; border: none"
                          >
                            <i class="ri-delete-bin-2-line text-danger"></i>
                          </a>
                          <slot
                            name="table-data-action"
                            v-bind:rowData="b.real"
                          ></slot>
                        </div>
                      </td>
                      <td v-if="indexNumber">
                        {{ paramAPI.limit * (paramAPI.page - 1) + (i + 1) }}.
                      </td>
                      <td
                        v-for="(h, j) in orderedFields"
                        :key="j"
                        :class="{ sticky: j === -10 }"
                      >
                        <template
                          v-if="h.type === 'slot' || h.type === 'row-slot'"
                        >
                          <slot
                            v-if="h.type === 'slot'"
                            :name="h.id"
                            v-bind:rowData="b.real[h.id]"
                            v-bind:indicator="indicator ? indicator : null"
                          ></slot>
                          <slot
                            v-else-if="h.type === 'row-slot'"
                            :name="h.id"
                            v-bind:rowData="b.real"
                            v-bind:indicator="indicator ? indicator : null"
                          ></slot>
                        </template>
                        <template v-else>
                          <div
                            v-if="b.mask[h.id] instanceof Array"
                            class="d-flex align-items-center"
                          >
                            <template v-for="(v, k) in b.mask[h.id]">
                              <template v-if="v.data instanceof Array">
                                <template v-if="v.type === 'text'">
                                  <span
                                    v-for="(d, l) in v.data"
                                    :key="k + '-value-multiple' + l"
                                    class="text-line-2"
                                    :class="classReader(d, h.class)"
                                  >
                                    {{ d | parse(h.transform) }}
                                    {{ l != v.data.length - 1 ? ", " : " " }}
                                  </span>
                                </template>
                                <template v-else-if="v.type === 'button'">
                                  <a
                                    v-for="(d, l) in v.data"
                                    :key="k + '-value-multiple-' + l"
                                    class="btn btn-sm"
                                    :class="[
                                      classReader(d, h.class)
                                        ? classReader(d, h.class)
                                        : 'btn-primary',
                                    ]"
                                    @click="h.event.click"
                                  >
                                    {{ d | parse(h.transform) }}
                                  </a>
                                </template>
                                <template v-else-if="v.type === 'file'">
                                  <img
                                    v-for="(d, l) in v.data"
                                    :key="k + '-value-multiple-' + l"
                                    class="img-table"
                                    :class="classReader(d, h.class)"
                                    v-img-fb="d"
                                    :alt="h.id"
                                    @click="emitEvent('zoom', d)"
                                  />
                                </template>
                                <template v-else>
                                  <span :key="k + '-value-multiple-' + l"
                                    >{{ $t("error.view_type") }}
                                    {{ "(" + v.type + ")" }}
                                  </span>
                                </template>
                              </template>
                              <template v-else>
                                <span
                                  v-if="v.type === 'text'"
                                  :key="k + '-value'"
                                  class="text-line-2"
                                  :class="classReader(v, h.class[k])"
                                >
                                  {{ v.data | parse(h.transform[k]) }}
                                </span>
                                <a
                                  v-else-if="v.type === 'button'"
                                  :key="k + 'btn-value'"
                                  class="btn btn-sm"
                                  :class="[
                                    classReader(v, h.class[k])
                                      ? classReader(v, h.class[k])
                                      : 'btn-primary',
                                  ]"
                                  @click="h.event.click[k]"
                                >
                                  {{ v.data | parse(h.transform[k]) }}
                                </a>
                                <img
                                  v-else-if="v.type === 'file'"
                                  :key="k + 'file-value'"
                                  class="img-table"
                                  :class="classReader(v, h.class[k])"
                                  v-img-fb="v.data"
                                  :alt="h.id"
                                  @click="emitEvent('zoom', v.data)"
                                />
                                <span v-else :key="k + 'error-value'"
                                  >{{ $t("error.view_type") }}
                                  {{ "(" + v.type + ")" }}</span
                                >
                              </template>
                            </template>
                          </div>
                          <template v-else>
                            <template v-if="b.mask[h.id].data instanceof Array">
                              <template v-if="b.mask[h.id].type === 'text'">
                                <span
                                  v-for="(d, k) in b.mask[h.id].data"
                                  :key="k + '-value'"
                                  class="text-line-2"
                                  :class="classReader(d, h.class)"
                                >
                                  {{ d | parse(h.transform) }}
                                  {{
                                    k != b.mask[h.id].data.length - 1
                                      ? ", "
                                      : " "
                                  }}
                                </span>
                              </template>
                              <template
                                v-else-if="b.mask[h.id].type === 'button'"
                              >
                                <a
                                  v-for="(d, k) in b.mask[h.id].data"
                                  :key="k + '-value'"
                                  class="btn btn-sm"
                                  :class="[
                                    classReader(d, h.class)
                                      ? classReader(d, h.class)
                                      : 'btn-primary',
                                  ]"
                                  @click="h.event.click"
                                >
                                  {{ d | parse(h.transform) }}
                                </a>
                              </template>
                              <template
                                v-else-if="b.mask[h.id].type === 'file'"
                              >
                                <img
                                  v-for="(d, k) in b.mask[h.id].data"
                                  :key="k + '-value'"
                                  class="img-table"
                                  :class="classReader(d, h.class)"
                                  v-img-fb="d"
                                  :alt="h.id"
                                  @click="emitEvent('zoom', d)"
                                />
                              </template>
                              <template v-else>
                                <span :key="k + '-value'"
                                  >{{ $t("error.view_type") }}
                                  {{ "(" + b.mask[h.id].type + ")" }}</span
                                >
                              </template>
                            </template>
                            <template v-else>
                              <span
                                v-if="b.mask[h.id].type === 'text'"
                                class="text-line-2"
                                :class="classReader(b.mask[h.id].data, h.class)"
                              >
                                {{ b.mask[h.id].data | parse(h.transform) }}
                              </span>
                              <div
                                v-else-if="b.mask[h.id].type === 'money'"
                                class="d-flex justify-content-between"
                              >
                                <span class="">Rp.</span>
                                <span class="text-right">
                                  {{ b.mask[h.id].data | parse(h.transform) }}
                                </span>
                              </div>
                              <div
                                v-else-if="b.mask[h.id].type === 'link'"
                                class="d-flex justify-content-between"
                              >
                                <a
                                  @click="
                                    b.mask[h.id].link
                                      ? $router.push({
                                          path: b.mask[h.id].link,
                                          query: {
                                            view: b.mask[h.id].param_id
                                              ? 'detail'
                                              : 'list',
                                            id: b.mask[h.id].param_id
                                              ? b.real[b.mask[h.id].param_id]
                                              : null,
                                            ...(b.mask[h.id].param
                                              ? b.mask[h.id].param
                                              : {}),
                                          },
                                        })
                                      : null
                                  "
                                  class="link text-primary font-weight-bold"
                                >
                                  {{ b.mask[h.id].data | parse(h.transform) }}
                                </a>
                              </div>
                              <a
                                v-else-if="b.mask[h.id].type === 'button'"
                                class="btn btn-sm"
                                :class="[
                                  classReader(b.mask[h.id].data, h.class)
                                    ? classReader(b.mask[h.id].data, h.class)
                                    : 'btn-primary',
                                ]"
                                @click="h.event.click"
                              >
                                {{ b.mask[h.id].data | parse(h.transform) }}
                              </a>
                              <img
                                v-else-if="b.mask[h.id].type === 'file'"
                                class="img-table"
                                :class="classReader(b.mask[h.id].data, h.class)"
                                v-img-fb="b.mask[h.id].data"
                                :alt="h.id"
                                @click="emitEvent('zoom', b.mask[h.id].data)"
                              />
                              <span v-else
                                >{{ $t("error.view_type") }}
                                {{ "(" + b.mask[h.id].type + ")" }}</span
                              >
                            </template>
                          </template>
                        </template>
                      </td>
                    </tr>
                    <!-- Detail Preview TR  -->
                    <template v-if="b && b.real && b.real.isActive">
                      <tr :key="i + '-body-detail'" class="detail-preview-row">
                        <td
                          :colspan="
                            orderedFields.length + 2 + (indexNumber ? 1 : 0)
                          "
                        >
                          <slot
                            name="detail-preview"
                            v-bind:rowData="b && b.real && b.real"
                          ></slot>
                        </td>
                      </tr>
                    </template>
                  </template>
                </template>

                <!-- non expandable view here -->
                <template v-else>
                  <template v-for="(b, i) in mainData">
                    <tr
                      :key="i + '-body'"
                      @click="onRowClick(b)"
                      :class="{
                        'hover-pointer': listConfig.id && listConfig.view,
                      }"
                    >
                      <td
                        class="sticky"
                        v-if="
                          ($_sys.isAllowed(permission.read) ||
                            $_sys.isAllowed(permission.update) ||
                            $_sys.isAllowed(permission.delete)) &&
                          !hideAction
                        "
                      >
                        <div
                          class="d-flex flex-row justify-content-center align-items-center"
                        >
                          <slot
                            name="table-action-detail-button"
                            v-bind:rowData="b.real"
                          >
                            <a
                              v-if="
                                !hideAction &&
                                !hideDetail &&
                                $_sys.isAllowed(permission.read)
                              "
                              v-b-tooltip.top.viewport="$t('global.detail')"
                              @click="emitEvent('detail', b.real)"
                              class="btn btn-icon btn-info btn-xs mx-1"
                              style="
                                background-color: rgba(0, 207, 232, 0.12);
                                border: none;
                              "
                            >
                              <slot name="table-action-detail-icon">
                                <i class="ri-information-line text-primary"></i>
                              </slot>
                            </a>
                          </slot>

                          <slot
                            name="table-action-update-button"
                            v-bind:rowData="b.real"
                          >
                            <a
                              v-b-tooltip.top.viewport="$t('global.update')"
                              @click="emitEvent('update', b.real)"
                              v-if="
                                !hideAction &&
                                !hideUpdate &&
                                $_sys.isAllowed(permission.update)
                              "
                              class="btn btn-icon btn-warning btn-xs mx-1"
                              style="
                                background-color: rgba(255, 159, 67, 0.12);
                                border: none;
                              "
                            >
                              <i class="ri-edit-2-line text-warning"></i>
                            </a>
                          </slot>
                          <a
                            v-b-tooltip.top.viewport="$t('global.delete')"
                            @click="deleteData(b.real)"
                            v-if="
                              !hideAction &&
                              !hideDelete &&
                              $_sys.isAllowed(permission.delete)
                            "
                            class="btn btn-icon btn-danger btn-xs mx-1"
                            style="background-color: #ffe2e5; border: none"
                          >
                            <i class="ri-delete-bin-2-line text-danger"></i>
                          </a>
                          <slot
                            name="table-data-action"
                            v-bind:rowData="b.real"
                          ></slot>
                        </div>

                        <slot
                          name="action-ext-button"
                          v-bind:rowData="b.real"
                        ></slot>
                      </td>
                      <td v-if="indexNumber">
                        {{ paramAPI.limit * (paramAPI.page - 1) + (i + 1) }}.
                      </td>
                      <td
                        v-for="(h, j) in orderedFields"
                        :key="j"
                        :class="{ sticky: j === -10, [h.row_class]: true }"
                      >
                        <template
                          v-if="h.type === 'slot' || h.type === 'row-slot'"
                        >
                          <slot
                            v-if="h.type === 'slot'"
                            :name="h.id"
                            v-bind:rowData="b.real[h.id]"
                            v-bind:indicator="indicator"
                            v-bind:indexIndicator="indexIndicator"
                          ></slot>
                          <slot
                            v-else-if="h.type === 'row-slot'"
                            :name="h.id"
                            v-bind:rowData="b.real"
                            v-bind:indicator="indicator"
                            v-bind:indexIndicator="indexIndicator"
                          ></slot>
                        </template>
                        <template v-else>
                          <div
                            v-if="b.mask[h.id] instanceof Array"
                            class="d-flex align-items-center"
                          >
                            <template v-for="(v, k) in b.mask[h.id]">
                              <template v-if="v.data instanceof Array">
                                <template v-if="v.type === 'text'">
                                  <span
                                    v-for="(d, l) in v.data"
                                    :key="k + '-value-multiple' + l"
                                    class="text-line-2"
                                    :class="classReader(d, h.class)"
                                  >
                                    {{ d | parse(h.transform) }}
                                    {{ l != v.data.length - 1 ? ", " : " " }}
                                  </span>
                                </template>
                                <template v-else-if="v.type === 'button'">
                                  <a
                                    v-for="(d, l) in v.data"
                                    :key="k + '-value-multiple-' + l"
                                    class="btn btn-sm"
                                    :class="[
                                      classReader(d, h.class)
                                        ? classReader(d, h.class)
                                        : 'btn-primary',
                                    ]"
                                    @click="h.event.click"
                                  >
                                    {{ d | parse(h.transform) }}
                                  </a>
                                </template>
                                <template v-else-if="v.type === 'file'">
                                  <img
                                    v-for="(d, l) in v.data"
                                    :key="k + '-value-multiple-' + l"
                                    class="img-table"
                                    :class="classReader(d, h.class)"
                                    v-img-fb="d"
                                    :alt="h.id"
                                    @click="emitEvent('zoom', d)"
                                  />
                                </template>
                                <template v-else>
                                  <span :key="k + '-value-multiple-' + l"
                                    >{{ $t("error.view_type") }}
                                    {{ "(" + v.type + ")" }}
                                  </span>
                                </template>
                              </template>
                              <template v-else>
                                <span
                                  v-if="v.type === 'text'"
                                  :key="k + '-value'"
                                  class="text-line-2"
                                  :class="classReader(v, h.class[k])"
                                >
                                  {{ v.data | parse(h.transform[k]) }}
                                </span>
                                <a
                                  v-else-if="v.type === 'button'"
                                  :key="k + 'button-value'"
                                  class="btn btn-sm"
                                  :class="[
                                    classReader(v, h.class[k])
                                      ? classReader(v, h.class[k])
                                      : 'btn-primary',
                                  ]"
                                  @click="h.event.click[k]"
                                >
                                  {{ v.data | parse(h.transform[k]) }}
                                </a>
                                <img
                                  v-else-if="v.type === 'file'"
                                  :key="k + 'file-value'"
                                  class="img-table"
                                  :class="classReader(v, h.class[k])"
                                  v-img-fb="v.data"
                                  :alt="h.id"
                                  @click="emitEvent('zoom', v.data)"
                                />
                                <span v-else :key="k + 'error-value'"
                                  >{{ $t("error.view_type") }}
                                  {{ "(" + v.type + ")" }}</span
                                >
                              </template>
                            </template>
                          </div>
                          <template v-else>
                            <template v-if="b.mask[h.id].data instanceof Array">
                              <template v-if="b.mask[h.id].type === 'text'">
                                <span
                                  v-for="(d, k) in b.mask[h.id].data"
                                  :key="k + '-value'"
                                  class="text-line-2"
                                  :class="classReader(d, h.class)"
                                >
                                  {{ d | parse(h.transform) }}
                                  {{
                                    k != b.mask[h.id].data.length - 1
                                      ? ", "
                                      : " "
                                  }}
                                </span>
                              </template>
                              <template
                                v-else-if="b.mask[h.id].type === 'button'"
                              >
                                <a
                                  v-for="(d, k) in b.mask[h.id].data"
                                  :key="k + '-value'"
                                  class="btn btn-sm"
                                  :class="[
                                    classReader(d, h.class)
                                      ? classReader(d, h.class)
                                      : 'btn-primary',
                                  ]"
                                  @click="h.event.click"
                                >
                                  {{ d | parse(h.transform) }}
                                </a>
                              </template>
                              <template
                                v-else-if="b.mask[h.id].type === 'file'"
                              >
                                <img
                                  v-for="(d, k) in b.mask[h.id].data"
                                  :key="k + '-value'"
                                  class="img-table"
                                  :class="classReader(d, h.class)"
                                  v-img-fb="d"
                                  :alt="h.id"
                                  @click="emitEvent('zoom', d)"
                                />
                              </template>
                              <template v-else>
                                <span :key="k + '-value'"
                                  >{{ $t("error.view_type") }}
                                  {{ "(" + b.mask[h.id].type + ")" }}</span
                                >
                              </template>
                            </template>
                            <template v-else>
                              <span
                                v-if="b.mask[h.id].type === 'text'"
                                class="text-line-2"
                                :class="classReader(b.mask[h.id].data, h.class)"
                              >
                                <span v-if="h.parse_static_option">
                                  {{
                                    $_sys.staticOptionLabel(
                                      b.mask[h.id].data,
                                      h.parse_static_option
                                    )
                                  }}
                                </span>
                                <span v-else>
                                  {{ b.mask[h.id].data | parse(h.transform) }}
                                </span>
                              </span>
                              <div
                                v-else-if="b.mask[h.id].type === 'money'"
                                class="d-flex justify-content-between"
                              >
                                <span class="">Rp.</span>
                                <span class="text-right">
                                  {{ b.mask[h.id].data | parse(h.transform) }}
                                </span>
                              </div>
                              <div
                                v-else-if="b.mask[h.id].type === 'date'"
                                class="d-flex justify-content-between"
                              >
                                <span>{{
                                  b.mask[h.id].data | dateFormat
                                }}</span>
                              </div>
                              <div
                                v-else-if="b.mask[h.id].type === 'time'"
                                class="d-flex justify-content-between"
                              >
                                <span>{{
                                  b.mask[h.id].data | timeFormat
                                }}</span>
                              </div>
                              <a
                                v-else-if="b.mask[h.id].type === 'button'"
                                class="btn btn-sm"
                                :class="[
                                  classReader(b.mask[h.id].data, h.class)
                                    ? classReader(b.mask[h.id].data, h.class)
                                    : 'btn-primary',
                                ]"
                                @click="h.event.click"
                              >
                                {{ b.mask[h.id].data | parse(h.transform) }}
                              </a>
                              <img
                                v-else-if="b.mask[h.id].type === 'file'"
                                class="img-table"
                                :class="classReader(b.mask[h.id].data, h.class)"
                                v-img-fb="b.mask[h.id].data"
                                :alt="h.id"
                                @click="emitEvent('zoom', b.mask[h.id].data)"
                              />
                              <span v-else
                                >{{ $t("error.view_type") }}
                                {{ "(" + b.mask[h.id].type + ")" }}</span
                              >
                            </template>
                          </template>
                        </template>
                      </td>
                    </tr>
                  </template>
                </template>
              </tbody>
              <!-- Footer Table  -->
              <slot
                name="list-footer-table"
                v-bind:rowData="mainData"
                v-bind:summary="dataSummary"
              ></slot>
            </table>
          </div>

          <div
            v-if="isLoading && mainData.length === 0"
            style="height: 10vh"
            class="d-flex flex-column justify-content-center align-items-center"
          >
            <img src="@/assets/lottie/plant.gif" style="width: 5em" />
          </div>
          <template v-if="mainData.length === 0 && !isLoading">
            <slot name="empty-data">
              <div class="text-center my-3">
                <img
                  src="/static/img/qhse/no-data_form.svg"
                  style="width: 120px; margin: 2em 0"
                  alt=""
                />
                <p v-if="!paramAPI.search">Belum ada data yang ditambahkan</p>
                <p v-else>{{ paramAPI.search }} tidak ditemukan</p>
              </div>
            </slot>
          </template>

          <!-- <h3>Total {{ total }}. Limit {{ paramAPI.limit}}</h3> -->
          <div
            v-if="mainData.length > 0"
            class="d-flex justify-content-between align-items-center flex-wrap"
          >
            <div class="pagination d-flex flex-wrap py-2 mr-3">
              <button
                type="button"
                @click="goPage('first')"
                :disabled="paramAPI.page == 1"
                class="btn btn-text btn-icon btn-sm btn-outline-primary mr-1 my-1"
              >
                <i class="ri-skip-back-mini-line"></i>
              </button>
              <button
                type="button"
                @click="goPage('prev')"
                :disabled="paramAPI.page == 1"
                class="btn btn-text btn-sm btn-outline-primary mr-1 my-1"
              >
                {{ $t("global.prev") }}
              </button>
              <input
                @change="goPage('input')"
                v-model.lazy="paramAPI.page"
                type="text"
                name="pagination"
                autocomplete="off"
                class="form-control form-control-sm pagination-text mr-1 my-1"
                :placeholder="$t('global.goto')"
              />
              <button
                type="button"
                @click="goPage('next')"
                :disabled="paramAPI.page == maxPage"
                class="btn btn-text btn-sm btn-outline-primary mr-1 my-1"
              >
                {{ $t("global.next") }}
              </button>
              <button
                type="button"
                @click="goPage('last')"
                :disabled="paramAPI.page == maxPage"
                class="btn btn-text btn-icon btn-sm btn-outline-primary mr-1 my-1"
              >
                <i class="ri-skip-forward-mini-line"></i>
              </button>
            </div>
            <div class="d-flex align-items-center py-3">
              <div v-if="isLoading" class="d-flex align-items-center">
                <div class="mr-2 text-muted">{{ $t("global.loading") }} ...</div>
                <div class="spinner spinner-primary mr-10"></div>
              </div>
              <v-select
                class="limit-table mr-4"
                placeholder="Limit Data"
                v-model="paramAPI.limit"
                :value="paramAPI.limit"
                append-to-body
                :searchable="false"
                :clearable="false"
                :options="[5, 10, 20, 50, 100]"
              ></v-select>
              <span class="text-muted">{{ detailPagination }}</span>
            </div>
          </div>
        </div>
        <b-modal
          :hide-footer="true"
          size="lg"
          centered
          id="modal-visibility"
          :title="
            $t('global.visibility') +
            ' Tabel ' +
            (titleKey ? $t(`menu.${titleKey}`) : title)
          "
        >
          <div class="row">
            <div
              v-for="(v, y) in fields"
              :key="y + '-visibility'"
              class="col-lg-6 col-sm-12"
            >
              <div class="form-group row align-items-center">
                <label
                  :for="v.data"
                  class="col-lg-8 col-9 col-form-label text-capitalize"
                  >{{ v.label }}</label
                >
                <div class="col-3">
                  <span class="switch switch-icon">
                    <label>
                      <input
                        :id="v.data"
                        v-model="v.show"
                        type="checkbox"
                        checked="checked"
                        name="select"
                        :true-value="true"
                        :false-value="false"
                      />
                      <span></span>
                    </label>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </slot>
  </div>
</template>
<script>
import moment from "moment";
import _, { isSet } from "lodash";
import _config from "@/config.js";

export default {
  name: "main-table",
  props: {
    refreshToken: {
      type: Number,
      default: 0
    },
    titleKey: {
      type: String,
      required: false,
      default: () => null,
    },
    titleIcon: {
      type: String,
      required: false,
      default: () => null,
    },
    activeView: { type: String, required: false },
    API: { type: String, required: true },
    indexNumber: { type: Boolean, required: false, default: () => true },
    endpoint: { type: Object, required: true },
    fields: { type: Array, required: true },
    exportExcel: { type: Boolean, required: false, default: () => true },
    import: { type: Boolean, required: false },
    title: { type: String, required: true },
    permission: { type: Object, required: true },
    slave: { type: Boolean, required: false, default: false },
    custom_delete: {type: Object, required: false},
    toolbar: { type: Boolean, required: false, default: true },
    filterData: { type: Array, required: true },
    listConfig: { type: Object, required: true },
    filter_param: {
      type: Object,
      required: false,
    },
    hideAction: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    search: { type: Boolean, required: false, default: true },
    toolbarType: {
      type: Number,
      required: false,
      default() {
        return 1;
      },
    },
    filters: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    hideFilter: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    hideRefresh: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    isCustomAPI: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    customEvent: {
      type: [Object, Boolean],
      required: false,
      default() {
        return false;
      },
    },
    hideCreate: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },

    hideDetail: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },

    hideUpdate: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },

    hideDelete: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },

    hideTitle: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },

    filter: {},
    detailPreview: { type: Boolean, required: false },
    exportPath: {
      type: String,
      required: false,
      default() {
        return null;
      },
    },

    toolbarClass: {
      type: String,
      required: false,
      default() {
        return "";
      },
    },
    multiExpand: {
      type: Boolean,
      default: false
    },
    hideExpandButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      indicator: null,
      dataSummary: null,
      showFilter: false,
      tmp_options: [],
      orderID: "",
      total: 0,
      maxPage: 0,
      mainData: [],
      orderedFields: [],
      custom_middle: false,
      isLoading: true,
      defaultLabels: {},
      paramAPI: {
        page: 1,
        limit: 10,
        order: "",
        sort: "DESC",
        search: "",
        filters: {},
      },
      inputSearch: null,
      exportLabel: {},
      indexIndicator: null,
      exportData: null,
      isLoadingExport: false,
      responseAPI: {},
      dateFormatter: {
        // Date to String
        stringify: (date) => {
          return date ? moment(date).format("YYYY-MM-DD") : null;
        },
        // String to Date
        parse: (value) => {
          return value ? moment(value, "YYYY-MM-DD").toDate() : null;
        },
      },
    };
  },
  mounted() {
    this.buildField();
    if (
      this.listConfig &&
      typeof this.listConfig === "object" &&
      this.listConfig.initialFilter &&
      typeof this.listConfig.initialFilter === "object"
    ) {
      this.paramAPI.filters = Object.assign(
        this.paramAPI.filters,
        this.listConfig.initialFilter
      );
    }

    if (
      typeof this.filter_param === "object" &&
      Object.keys(this.filter_param).length > 0
    ) {
      var _paramApi = JSON.parse(JSON.stringify(this.paramAPI));
      if (this.filter_param) {
        _paramApi = Object.assign(_paramApi, this.filter_param);
      }

      this.paramAPI = _paramApi;
    }

    for (const value of this.filterData) {
      const filterKey = value.view_data || value.id;
      if (value.type == "year") {
        if (!this.$route.query[filterKey]) {
          this.paramAPI.filters[filterKey] = _config.options.yearDefault;
        }
      }

      if (
        !this.$route.query[filterKey] &&
        !["daterange", "date"].includes(value.type)
      )
        continue;

      /* if (
        ["daterange"].includes(value.type) &&
        Array.isArray(this.$route.query[filterKey]) &&
        this.$route.query[filterKey].length === 2
      ) {
        this.paramAPI.filters[filterKey] = [
          this.$route.query[filterKey][0],
          this.$route.query[filterKey][1],
        ];
      } else {
        this.paramAPI.filters[filterKey] = this.$route.query[filterKey];
      } */
      if (
        value.type === "daterange" &&
        Array.isArray(this.temporary_date) &&
        this.temporary_date.length === 2 &&
        !this.$route.query[filterKey]
      ) {
        this.paramAPI.filters[filterKey] = this.temporary_date;
      } else if (
        value.type === "date" &&
        Array.isArray(this.temporary_date) &&
        this.temporary_date.length === 1 &&
        !this.$route.query[filterKey]
      ) {
        this.paramAPI.filters[filterKey] =
          value.data_type === "array"
            ? this.temporary_date
            : this.temporary_date[0];
      } else {
        this.paramAPI.filters[filterKey] = this.$route.query[filterKey];
        const defaultLabelKey = filterKey
          .replace("_code", "_name")
          .replace("_id", "_name");
        if (this.$route.query[defaultLabelKey]) {
          this.defaultLabels[defaultLabelKey] =
            this.$route.query[defaultLabelKey];
        }
      }

      if (
        this.$route.query[filterKey] &&
        Array.isArray(this.$route.query[filterKey]) &&
        value.type === "daterange" &&
        this.$route.query[filterKey].length === 2
      ) {
        this.paramAPI.filters[filterKey] = this.$route.query[filterKey];
      } else if (
        value.type === "date" &&
        this.$route.query[filterKey] &&
        moment(this.$route.query[filterKey], "YYYY-MM-DD").isValid()
      ) {
        this.paramAPI.filters[filterKey] =
          value.data_type === "array"
            ? [this.$route.query[filterKey]]
            : this.$route.query[filterKey];
      }
    }
  },
  computed: {
    year_options() {
      let yearOptions = [];
      for (const option of _config.options.yearOptions) {
        yearOptions.push({
          code: option,
          label: option,
        });
      }

      return yearOptions.reverse();
    },
    temporary_date() {
      return this.$store.state.temporary_date;
    },
    detailPagination() {
      let _inPage =
        this.paramAPI.limit > this.mainData.length
          ? this.mainData.length
          : this.paramAPI.limit;
      return (
        this.$t("global.display") +
        " " +
        _inPage +
        " " +
        this.$t("global.of") +
        " " +
        this.total +
        " " +
        this.$t("global.record")
      );
    },
    filterList() {
      let search;
      let filter = [];
      let _mask = this.paramAPI.filters || {};
      if (this.paramAPI.search && this.paramAPI.search !== "") {
        search = { id: "search", type: "search", value: this.paramAPI.search };
      } else search = null;
      if (this.fields && Object.entries(_mask).length !== 0) {
        Object.keys(_mask).forEach((e) => {
          let field = this.fields.filter((x) => x.id === e)[0];
          if (field) {
            let label = field.label;
            filter.push({ id: e, type: label, value: _mask[e], display: null });
          }
        });
      }
      if (search) filter.unshift(search);
      return filter;
    },
    urlProperties() {
      if (!this.slave) {
        return { ...this.$route.query, ...this.paramAPI };
      } else {
        return this.paramAPI;
      }
    },
  },
  watch: {
    urlProperties: {
      deep: true,
      immediate: false,
      handler(to) {
        this.getData(to);
      },
    },
    refreshToken: function () {
      this.getData(this.paramAPI)
    },
    filters: {
      deep: true,
      immediate: true,
      handler(to) {
        let param = Object.assign({}, this.paramAPI);
        param.page = 1;
        param.filters = to;

        // set default program year
        param.program_year = this.$store.state.program_year;

        this.paramAPI = Object.assign(this.paramAPI, param);
      },
    },
    "$route.query": {
      deep: true,
      immediate: true,
      handler(to, from) {
        if (to === "list") this.isLoading = true;
        if (!to.page && !this.slave) this.changeParam(this.paramAPI, true);
      },
    },
    inputSearch: {
      deep: false,
      immediate: false,
      handler(to) {
        let param = Object.assign({}, this.paramAPI);
        param.page = 1;
        param.search = to;
        this.paramAPI = Object.assign(this.paramAPI, param);
      },
    },
    fields: {
      deep: true,
      immediate: true,
      handler(to) {
        this.buildField();
      },
    },

    // "paramAPI.filters": {
    //   deep: true,
    //   immediate: true,
    //   handler(t, f) {
    //     for (const filterKey of Object.keys(t)) {
    //       let filterObj = this.filterData.find(
    //         (x) => x.view_data === filterKey
    //       );
    //       if (!filterObj) continue;

    //       if (
    //         filterObj.type === "daterange" &&
    //         Array.isArray(t[filterKey]) &&
    //         t[filterKey].length === 2
    //       ) {
    //         this.$store.commit("set", ["temporary_date", t[filterKey], true]);
    //       } else if (
    //         filterObj.type === "daterange" &&
    //         !Array.isArray(t[filterKey])
    //       ) {
    //         this.$store.commit("set", ["temporary_date", null, true]);
    //       } else if (
    //         filterObj.type === "date" &&
    //         moment(t[filterKey]).isValid()
    //       ) {
    //         if (Array.isArray(t[filterKey]) && t[filterKey].length === 1) {
    //           this.$store.commit("set", ["temporary_date", t[filterKey], true]);
    //         } else {
    //           this.$store.commit("set", [
    //             "temporary_date",
    //             [t[filterKey]],
    //             true,
    //           ]);
    //         }
    //       } else if (
    //         filterObj.type === "date" &&
    //         moment(t[filterKey]).isValid() === false
    //       ) {
    //         this.$store.commit("set", ["temporary_date", null, true]);
    //       }
    //     }
    //   },
    // },

    "$store.state.program_year": {
      handler(t, f) {
        let param = Object.assign({}, this.paramAPI);
        param.page = 1;
        param.program_year = t;
        this.paramAPI = Object.assign(this.paramAPI, param);
        this.getData(this.paramAPI);
      },
    },
    "$store.state.role_code": {
      handler(t, f) {
        this.getData(this.paramAPI);
      },
    },
  },
  methods: {
    buildField() {
      let tmp_field = this.fields.filter(
        (x) => x.show && this.$_sys.isAllowed(x.permission)
      );

      if (this.listConfig.order && Array.isArray(this.listConfig.order)) {
        let tmp_field2 = [];
        for (var i = 0; i < this.listConfig.order.length; i++) {
          var idx = tmp_field.findIndex(
            (x) => x.id === this.listConfig.order[i]
          );
          if (idx > -1) {
            tmp_field2.push(tmp_field[idx]);
            tmp_field.splice(idx, 1);
          }
        }
        this.orderedFields = tmp_field2.concat(tmp_field);
      } else {
        this.orderedFields = tmp_field;
      }
    },
    onRowClick(data) {
      if (!this.listConfig.view && !this.listConfig.id) return;
      if (!data.real[this.listConfig.id]) return;
      try {
        let configParam =
          typeof this.listConfig.param === "object"
            ? this.listConfig.param
            : {};
        this.$router.push({
          path: this.listConfig.view,
          query: {
            view: "detail",
            id: data.real[this.listConfig.id],
            ...configParam,
          },
        });
      } catch (err) {
        console.log("err", err);
      }
    },
    onExportExcell() {
      let limit = 250;
      let totalRecord = this.total;
      let exportCount = Math.ceil(totalRecord / limit);

      if (this.exportPath) {
        for (var i = 0; i < exportCount; i++) {
          var exportParam = {
            sort: this.paramAPI.sort,
            limit: limit,
            offset: limit * i,
            search: this.paramAPI.search,
            order: this.paramAPI.order,
            ...this.paramAPI.filters,
          };

          this.$_api
            .export(this.exportPath, exportParam)
            .then((response) => {})
            .catch((err) => {
              console.error("onExportExcell error", err);
              this.$_alert.error(err);
            });
        }
      }
    },
    onFilter(item, e) {
      if (item) {
        let value = ["date", "daterange"].includes(item.type) ? e : e.code;
        let filterKey = item.id;
        if (item.params) {
          filterKey = item.params;
        }
        const filterValue = item.data_type === "array" ? [value] : value;

        let _newFilter = Object.assign(this.paramAPI.filters, {
          [filterKey]: filterValue,
        });

        for (const filterKey of Object.keys(_newFilter)) {
          let filterObj = this.filterData.find(
            (x) => x.view_data === filterKey
          );
          if (!filterObj) continue;

          if (
            filterObj.option.parent_filter &&
            !_newFilter[filterObj.view_data || filterObj.id]
          ) {
            _newFilter[filterObj.view_data || filterObj.id] = null;

            let filterData1 = this.filterData.find(
              (x) => x.id === filterObj.option.parent_filter
            );
            if (!filterData1) continue;

            //child filter lv 2
            if (
              filterData1.option.parent_filter &&
              !_newFilter[filterData1.view_data || filterData1.id]
            ) {
              _newFilter[filterData1.view_data || filterData1.id] = null;
            }
          }
        }

        //this.paramAPI.filters[filterKey] = filterValue
        // this.$set(this.paramAPI, "filters", _newFilter);
        this.paramAPI = Object.assign({}, this.paramAPI, {
          filters: _newFilter,
        });

        if (!value || (Array.isArray(value) && value.length > 0 && !value[0])) {
          this.paramAPI.filters[filterKey] = null;
        }

        this.getData(this.paramAPI);
      } else {
        this.paramAPI.filters = {};
        this.getData(this.paramAPI);
      }
    },
    getInitialData(data, i) {
      if (!data.getter) return;
      const idx = this.filterData.findIndex((x) => x.id === data.id);
      if (idx < 0) return;
      this.filterLoading = true;
      let param = {
        limit: 10,
      };

      this.$_api
        .dataset(data.getter, param)
        .then((res) => {
          let _data = [];

          for (const _value of res.data) {
            let _val = _value;
            _val.label = _value[data.option.list_pointer.label];
            _val.code = _value[data.option.list_pointer.code];
            _data.push(_val);
          }

          this.filterData[idx].options = _data;

          this.filterLoading = false;
        })
        .catch((err) => {
          this.$_alert.error(err);
          this.filterLoading = false;
        });
    },
    getInitialData(data, i) {
      if (!data.getter) return;
      const idx = this.filterData.findIndex((x) => x.id === data.id);
      if (idx < 0) return;
      let param = {
        limit: 10,
      };

      if (data.option && data.option.parent_filter) {
        const _parent = this.filterData.find(
          (x) =>
            x.id === data.option.parent_filter ||
            x.view_data === data.option.parent_filter
        );

        if (_parent && this.paramAPI.filters[_parent.id]) {
          param[data.option.parent_filter] = this.paramAPI.filters[_parent.id];
        }
      }
      this.$_api.dataset(data.getter, param).then((res) => {
        let _data = [];

        for (const _value of res.data) {
          let _val = _value;
          _val.label = _value[data.option.list_pointer.label];
          _val.code = _value[data.option.list_pointer.code];
          _data.push(_val);
        }

        this.filterData[idx].options = _data;
      });
    },

    searchDataOption: _.debounce(function (search, loading, data) {
      if (!data.getter) return;
      const idx = this.filterData.findIndex((x) => x.id === data.id);
      if (idx < 0) return;

      let filterKey = data.view_data ? data.view_data : data.id;

      if (!search && !this.paramAPI.filters[filterKey]) return;
      if (!search) return;

      loading(true);
      let param = {
        limit: 10,
        search: search,
      };

      this.$_api
        .dataset(data.getter, param)
        .then((res) => {
          let _data = [];

          for (const _value of res.data) {
            let _val = _value;
            _val.label = _value[data.option.list_pointer.label];
            _val.code = _value[data.option.list_pointer.code];
            _data.push(_val);
          }

          this.filterData[idx].options = _data;
          loading(false);
        })
        .catch(() => {
          loading(false);
        });
    }, 600),
    emitEvent(e, data = null) {
      const value = data || true;
      this.getData(this.paramAPI);
      this.$emit(e, value);
    },
    changeParam(e, replace) {
      let queryRoute = {
        page: e.page || 1,
        limit: e.limit || 10,
        order: e.order || "",
        sort: e.sort || "",
        search: e.search || "",
        filters:
          typeof e.filters === "string" ? e.filters : JSON.stringify(e.filters),
      };

      if (replace) {
        let _mask = queryRoute;
        _mask.page = String(_mask.page);
        _mask.limit = String(_mask.limit);
        if (JSON.stringify(this.$route.query) !== JSON.stringify(_mask)) {
          this.$router.replace({
            query: Object.assign({ ...this.$route.query }, queryRoute),
          });
        } else this.getData(e);
      } else this.getData(e);
    },
    async getExportData() {
      this.exportLabel = Object.assign({}, {});
      this.exportData = null;
      this.isLoadingExport = true;
      const param = Object.assign({}, this.paramAPI);
      delete param.limit;
      delete param.page;
      await this.$_api[this.isCustomAPI ? "get" : "dataset"](this.API, param)
        .then(async (res) => {
          if (res.data.length > 0) {
            await this.buildData(res.data, true).then((e) => {
              const data = e.map((x) => x.export);
              const header = this.fields.filter(
                (x) => x.show === true && this.$_sys.isAllowed(x.permission)
              );
              for (let iH = 0; iH < header.length; iH++) {
                const el = Object.assign({}, header[iH]);
                this.$set(this.exportLabel, el.label, el.id);
              }
              this.exportData = data;
            });
          } else {
            this.$_alert.error(
              null,
              "Data Kosong",
              "Tidak dapat mengeksport data kosong"
            );
          }
        })
        .catch((err) => {
          this.$_alert.error(err);
        });
    },
    getData(param) {
      this.isLoading = true;
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
      if (param) {
        if (param.filters) {
          param.filters =
            typeof param.filters === "string"
              ? JSON.parse(param.filters)
              : param.filters;
          if (this.slave) {
            // let _filter = { ...param.filters, ...this.$store.state.activeSlave.param }
            // eslint-disable-next-line standard/computed-property-even-spacing
            param.filters[this.$store.state.activeSlave.param] =
              this.$store.state.activeSlave.key;
          }
        } else param.filters = {};
      } else param = this.paramAPI;

      let tmpParam = Object.assign({});
      if (
        this.slave &&
        this.listConfig &&
        typeof this.listConfig.initialFilter === "object"
      ) {
        if (this.listConfig.initialFilter.production_unit_id) {
          this.$set(
            tmpParam,
            "production_unit_id",
            this.listConfig.initialFilter.production_unit_id
          );
        }

        if (this.listConfig.initialFilter) {
          tmpParam = Object.assign(tmpParam, this.listConfig.initialFilter);
        }
      }

      tmpParam = Object.assign(param, tmpParam);

      tmpParam = JSON.parse(JSON.stringify(tmpParam));

      this.$_api[this.isCustomAPI ? "get" : "list"](this.API, tmpParam).then(
        (e) => {
          e.total = e.total;
          let data = e.data;
          this.responseAPI = e.data;
          if (typeof e.data === "object" && e.data.summary) {
            this.dataSummary = e.data.summary;
          } else if (typeof e === "object" && e.summary) {
            this.dataSummary = e.summary;
          }

          if (typeof e.data === "object" && e.data.indicator) {
            this.indicator = e.data.indicator;
          } else if (typeof e === "object" && e.indicator) {
            this.indicator = e.indicator;
          }

          if (typeof e.data === "object" && e.data.index_indicator) {
            this.indexIndicator = e.data.index_indicator;
          } else if (typeof e === "object" && e.index_indicator) {
            this.indexIndicator = e.index_indicator;
          }

          if (!Array.isArray(e.data) && typeof e.data === "object") {
            data = e.data.data;
            e.total = e.total ? e.total : e.data.record;
          }
          this.total = e.total;

          this.mainData = [];
          this.maxPage = Math.ceil(e.total / param.limit);
          this.buildData(data).then((e) => {
            this.mainData = e;
            this.isLoading = false;
          });
        },
        (err) => {
          this.isLoading = false;
          console.log(err);
        }
      );
    },
    async buildData(data, fromExport = false) {
      return new Promise(async (resolve, reject) => {
        if (!Array.isArray(data)) reject();
        let result = [];
        await data.forEach((d) => {
          let newData = {};
          let newExport = {};
          this.fields.forEach((f) => {
            const transform = f.transform;
            if (f.view_data instanceof Array) {
              let newMask = [];
              // OLD BUILDER
              // f.view_data.forEach((v, i) => {
              // newMask.push({ type: f.type[i], data: this.renderVal(d, v) })
              // })
              // newData[f.id] = newMask

              //  VIEW DATA MULTIPLE
              f.view_data.forEach((v, i) => {
                let val = this.renderVal(d, v);
                if (val) newMask.push(val);
              });
              newData[f.id] = { type: f.type, data: `${newMask.join(", ")}` };
              // END VIEW DATA MULTIPLE
              if (fromExport) {
                if (transform) {
                  newExport[f.id] = newMask.map((x) =>
                    this.$options.filters.parse(x.data, transform)
                  );
                } else newExport[f.id] = newMask.map((x) => x.data);
              }
            } else {
              newData[f.id] = {
                link:
                  f.type === "link" && f.link
                    ? f.link.replace(":id", d.id)
                    : null,
                type: f.type,
                data: this.renderVal(d, f.view_data),
                param_id: f.param_id,
                param: f.param || {},
              };
              if (fromExport) {
                if (transform) {
                  newExport[f.id] = this.$options.filters.parse(
                    this.renderVal(d, f.view_data),
                    transform
                  );
                } else newExport[f.id] = this.renderVal(d, f.view_data);
              }
            }
          });
          let _temp = {
            real: d,
            mask: newData,
            export: newExport,
          };
          result.push(_temp);
        });
        resolve(result);
      });
    },
    renderVal(source, prop) {
      if (!prop) return null;
      let _index = prop.indexOf(".");
      if (_index > -1) {
        let e = prop.split(".");
        for (let i = 0; i < e.length; i++) {
          if (source[e[i]]) source = source[e[i]];
          else {
            if (Array.isArray(source)) {
              let tmp = [];
              source.forEach((el) => {
                tmp.push(el[e[i]]);
              });
              source = tmp;
            }
          }
        }
        return source;
      } else return source[prop];
    },
    classReader(value, classes) {
      if (classes instanceof Object) {
        if (value instanceof Array) {
          value.forEach((val) => {
            return classes[val];
          });
        } else return classes[value];
      } else return classes;
    },
    goPage(e, event = null) {
      switch (e) {
        case "first":
          this.paramAPI.page = 1;
          break;
        case "last":
          // this.paramAPI.page = Number(this.maxPage)
          let a = this.maxPage / this.paramAPI.limit;
          this.paramAPI.page =
            a - parseInt(a) > 0 ? parseInt(a.toFixed(0)) + 1 : a;
          break;
        case "next":
          this.paramAPI.page =
            this.paramAPI.page < this.maxPage
              ? Number(this.paramAPI.page) + 1
              : this.paramAPI.page;
          break;
        case "prev":
          this.paramAPI.page =
            this.paramAPI.page === 1
              ? this.paramAPI.page
              : Number(this.paramAPI.page) - 1;
          break;
        case "input":
          if (!isNaN(this.paramAPI.page)) {
            if (this.paramAPI.page > this.maxPage) {
              this.paramAPI.page = this.maxPage;
            } else if (this.paramAPI.page < 1) this.paramAPI.page = 1;
          }
          break;
      }
    },
    orderField(e) {
      if (e.order) {
        if (e.view_data instanceof Array) {
          if (e.view_data[0] !== this.paramAPI.order) {
            this.paramAPI.order = e.view_data[0];
            this.paramAPI.sort = "DESC";
            this.orderID = e.id;
          } else {
            this.paramAPI.sort = this.paramAPI.sort === "ASC" ? "DESC" : "ASC";
          }
        } else {
          if (e.view_data !== this.paramAPI.order) {
            this.paramAPI.order = e.view_data;
            this.paramAPI.sort = "DESC";
            this.orderID = e.id;
          } else {
            this.paramAPI.sort = this.paramAPI.sort === "ASC" ? "DESC" : "ASC";
          }
        }
      }
    },
    removeFilter(id = null) {
      if (!id) {
        this.paramAPI.search = "";
        this.paramAPI.filters = {};
      } else {
        if (id === "search") {
          this.paramAPI.search = "";
        } else {
          const _mask = { ...this.paramAPI.filters };
          delete _mask[id];
          this.$set(this.paramAPI, "filters", _mask);
        }
      }
    },
    async deleteData(data) {
      var deleteMessage= "Data yang sudah dihapus tidak dapat dikembalikan, lanjutkan?";
      if (this.custom_delete&&this.custom_delete.message) {
        deleteMessage = this.custom_delete.message;
      }
      const confirm = await this.$_alert.confirm("Hapus Permanen",deleteMessage,"Ya, Lanjutkan","Batal",true)
      if (!confirm.isConfirmed) return;
      this.isLoading = true;
      if(this.custom_delete && this.custom_delete.child_data){
        if(this.custom_delete.child_data.length > 0){
          for(const child_data of this.custom_delete.child_data){
            // get every child data first
            const childList = await this.$_api.get(`/${child_data.api}/list?${child_data.parent_parameter_id}=${data.id}`);
            console.log('child list data',childList.data)
            const childListId = childList.data.map(v => v.id);
            console.log('child list id', childListId)
            for(const childId of childListId)
              await this.$_api
              .delete(`/${child_data.api}`, { id: childId })
              .then((res) => {
                this.$_alert.success(
                  null,
                  res.message || "Child Data berhasil dihapus"
                );
              })
              .catch((err) => {
                this.$_alert.error(err);
              });
          }
        }
      }
      this.$_api
        // .delete(
        //   `${this.endpoint.delete.replace(":id", data.id)}/${data.id}`
        // )
        .delete(this.endpoint.delete, { id: data.id })
        .then((res) => {
          this.getData(this.paramAPI);
          this.$_alert.success(
            null,
            res.message || "Data berhasil dihapus"
          );
        })
        .catch((err) => {
          this.$_alert.error(err);
        });
      this.$emit('successful_deletion', data)
      this.isLoading=false;
    },
    toggleDetails(row, idx) {
      if (this.multiExpand) {
        // Toggle only the clicked row
        this.$set(row.real, 'isActive', !row.real.isActive);
      } else {
        // Collapse all, expand only the clicked row
        this.mainData.forEach((item, i) => {
          this.$set(item.real, 'isActive', i === idx ? !item.real.isActive : false);
        });
      }
    },
  },
};
</script>

<style>
.filter-wrapper .vs__search {
  padding: 0px;
}
.filter-wrapper .vs__search::placeholder {
  color: #226638 !important;
}
.filter-wrapper .vs__open-indicator {
  fill: #226638 !important;
}
.filter-wrapper .vs__dropdown-menu {
  transform: translateY(5px);
  padding-top: 0px;
  padding-bottom: 0px;
  border-radius: 12px;
}
.filter-wrapper .vs__dropdown-menu li {
  padding: 7px 20px;
}
.filter-wrapper .input-filter-date {
  background: #f3f6f9;
  height: 30px;
  min-width: 150px;
  border-radius: 30px;
  border: none !important;
  padding-left: 8px;
  padding-right: 8px;
}

.filter-wrapper .mx-datepicker.mx-datepicker-range {
  background: #f3f6f9;
  height: 30px;
  min-width: 150px;
  max-width: 250px;
  border-radius: 30px;
  border: none !important;
  padding-left: 8px;
  padding-right: 8px;
  overflow-x: hidden;
}

.filter-wrapper .mx-datepicker {
  background: #f3f6f9;
  height: 30px;
  min-width: 150px;
  max-width: 200px;
  border-radius: 30px;
  border: none !important;
  padding-left: 8px;
  padding-right: 8px;
  overflow-x: hidden;
}

.filter-wrapper .input-filter-daterange {
  background: #f3f6f9;
  height: 30px;
  width: 100%;
  border: none !important;
}

.limit-table .vs__dropdown-toggle {
  border: 1px solid #e4e6ef;
}

.limit-table .vs__open-indicator {
  fill: #d3d6e2;
}

.v-separator {
  border-right: 2px solid #e4e6ef;
  height: 100%;
}
</style>
<style scoped>
.sticky {
  position: sticky !important;
  left: 0 !important;
  background-color: #ffffff;
  z-index: 10;
  max-width: 200px;
  /* min-width: 150px; */
  /* width: 200px; */
}

.sticky-right {
  position: sticky !important;
  right: 0 !important;
  z-index: 2;
}

.pagination-text {
  width: 80px;
  text-align: center;
}

.seach-form {
  border-radius: 18px;
  background-color: #f4f4f4;
  border-color: #d5d5d5;
}
/* .seach-form::placeholder {
  color: #c5c5c5;
} */

.img-table {
  height: 50px;
  width: 50px;
  border-radius: 8px;
  object-fit: cover;
  cursor: pointer;
}

.table-hover tbody tr:hover td {
  color: #3f4254;
  background-color: #f5f5f5 !important;
}
.table-hover tbody tr.detail-preview-row:hover td {
  background-color: #fcfcfc !important;
}

.action-table {
  width: 1%;
  height: 100%;
  white-space: nowrap;
  text-align: right;
  position: relative;
}

.action-table .action-button {
  display: flex;
  align-items: center;
  position: absolute;
  top: 50%;
  right: 5px;
  background-color: transparent;
  transform: translate(0, -50%);
  height: 100%;
  transition: all 0.5s ease;
  opacity: 0;
  padding: 1rem;
}

.action-table .action-button a {
  margin-right: 0.25em;
}

.table-hover tbody tr:hover td.action-table .action-button {
  opacity: 1;
  background-color: #f5f5f5 !important;
}

.sort-table {
  transition: all 0.5s ease;
  position: absolute;
  top: 50%;
  right: 5px;
  transform: translate(0, -50%);
}

.toolbar-button-icon {
  border-radius: 50%;
  width: 40px;
  height: 40px;
}

.icon-filter {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  padding: 0;
  margin: 0;
  text-align: center;
  vertical-align: middle;
}

.icon-filter.text-white i {
  color: #fff !important;
}

.icon-filter i {
  margin: 0;
  padding: 0;

  color: #226638;
}

.toolbar-button i.text-white {
  color: white !important;
}

.toolbar-button {
  color: #226638 !important;
  margin: 0 0.8em;
}

.toolbar-button i {
  color: #226638 !important;
}

.bordered-right {
  border-right: 1px solid #e0e0e086;
}
</style>



// WEBPACK FOOTER //
// src/base/main-table.vue